import CampaignView from '@/views/CampaignView.vue';
import CampaignViewPopup from '@/views/CampaignViewPopup.vue';
import CampaignIframeQueueView from '@/views/CampaignIframeQueueView.vue';

export default [
  {
    path: '/campaign/view/demo/:campaignId/token:token',
    name: 'Campaign demo',
    component: () => import('../views/CampaignDemo.vue')
  },
  {
    path: '/campaign/view/popup/:campaignId/:hash',
    name: 'Campaign view popup',
    component: CampaignViewPopup
  },
  {
    path: '/campaign/view/iframe/0/hash:hash',
    name: 'Campaign view iframe queue',
    component: CampaignIframeQueueView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Campaign view',
    component: CampaignView
  }
];
